export * from './lib/catastro.module';
export { CatastroMenuComponent } from './lib/catastro-menu/catastro-menu.component'
